import { observer } from "mobx-react";
import { OFTableController } from "../OFTableController";
import RenderHeaderCell from "./RenderHeaderCell";

const StaticHeader = observer(({ ofTableController }: { ofTableController: OFTableController }) => {
  console.log("RENDER StaticHeader");

  const renderHeader = () => {
    const { visibleColumns } = ofTableController;
    //console.log(visibleColumns);

    const cols = [];

    visibleColumns.forEach((col, index) => {
      if (col.subColumns) {
        col.subColumns.forEach((subCol, subIndex) => {
          cols.push(<RenderHeaderCell key={subCol.id} column={subCol} columnIndex={subIndex} ofTableController={ofTableController} />);
        });
      } else {
        cols.push(<RenderHeaderCell key={col.id} column={col} columnIndex={index} ofTableController={ofTableController} />);
      }
    });

    return cols;
  };

  return (
    <div className="tableHeader" style={{ position: "sticky", top: 0 }}>
      <div className="ReactVirtualized__Grid__innerScrollContainer flex">{renderHeader()}</div>
    </div>
  );
});

export default StaticHeader;
